import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'



const configDataSlice = createSlice({
    name: 'appConfig',
    initialState: { 
        landingDesc: `Makeup, hairstyling, and saree draping, thoughtfully tailored to you and the occasion.`,
    makeupAbout:'',
    },
    reducers: {
      getAbout(state, action) {
        state.makeupAbout = action.payload
      },
    },
  })
  
  
  export const { getAbout } = configDataSlice.actions
  export default configDataSlice;
  
